export interface MinutaPendencySummaryLike {
  awaitingInspector: number;
  awaitingValidation: number;
  corrected: number;
  canComplete: boolean;
}

export interface MinutaValidateButtonState {
  enabled: boolean;
  reasons: string[];
}

/**
 * Decides whether "Validar Minuta" should be enabled, and why not when it
 * isn't (Bloco 8, Parte C). Extracted as a pure function so the actual
 * decision — not just its rendering — is unit-testable: the previous
 * implementation folded this into a JSX-like switch statement that replaced
 * the button entirely with plain text whenever there were pendencies,
 * making "Validar Minuta" disappear instead of appearing disabled with a
 * reason.
 */
export function computeValidateMinutaState(pendencySummary: MinutaPendencySummaryLike): MinutaValidateButtonState {
  const reasons: string[] = [];
  if (pendencySummary.awaitingInspector > 0) reasons.push(`${pendencySummary.awaitingInspector} correção(ões) aguardando o Inspetor`);
  if (pendencySummary.awaitingValidation > 0) reasons.push(`${pendencySummary.awaitingValidation} correção(ões) aguardando validação`);
  if (pendencySummary.corrected > 0) reasons.push(`${pendencySummary.corrected} correção(ões) corrigida(s) não validada(s)`);
  return { enabled: pendencySummary.canComplete, reasons };
}
